import { guestConstants } from "../constants";
import { userConstants } from "../constants/user.constants";
import { isRedirectPage } from "../utils/user";
import { proConstants } from "../constants/pro";

const initialState = {
  forgotPasswordMailSent: false,
  isTokenCheck: null,
  user: {}
};

export function authentication(state = initialState, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {
    case guestConstants.LOGIN_REQUEST:
      break;
    case guestConstants.LOGIN_SUCCESS:
      let data = { ...action.payload };
      delete data["authorize_token"];
      currentstate = {
        loggedIn: true,
        user: data,
        redirect_page: isRedirectPage(),
      };
      break;
    case guestConstants.LOGIN_FAILURE:
      break;

    case userConstants.UPDATE_BASIC_DETAIL_REQUEST:
    case guestConstants.REGISTER_REQUEST:
      break;
    case userConstants.UPDATE_BASIC_DETAIL_SUCCESS:
    case guestConstants.REGISTER_SUCCESS:
    case userConstants.GET_BASIC_DETAIL_SUCCESS:
      currentstate = {
        loggedIn: true,
        user: {
          ...oldstate.user,
          ...action.payload
        },
        redirect_page: isRedirectPage(),
      };
      break;
    case userConstants.UPDATE_BASIC_DETAIL_FAILURE:
    case guestConstants.REGISTER_FAILURE:
      break;

    case proConstants.BALANCE_UPDATE_SUCCESS:
      let oldUserState = { ...oldstate.user };
      delete oldUserState["balance"];
      delete oldUserState["total_leads_purchased"];
      if(action.payload.balance !== undefined) {
        oldUserState.balance = action.payload.balance
      } else if(action.payload.total_leads_purchased !== undefined) {
        oldUserState.total_leads_purchased = action.payload.total_leads_purchased
      }
      currentstate = {
        user: oldUserState
      };
      break;

    case userConstants.LOGOUT_SUCCESS:
      currentstate = { loggedIn: false, user: {} };
      break;

    case guestConstants.EMAIL_EXIST_REQUEST:
      currentstate = {
        signupStep1Data: action.payload
      };
      break;
    case guestConstants.EMAIL_EXIST_SUCCESS:
      currentstate = {
        isEmailExist: action.payload && !action.payload.status
      };
      break;
    case guestConstants.EMAIL_EXIST_FAILURE:
      break;


    //#region Forget Password
    case guestConstants.FORGOTPWD_SUCCESS:
      currentstate = { forgotPasswordMailSent: true };
      break;

    case guestConstants.VALIDATE_PASSWORD_TOKEN_SUCCESS:
      currentstate = { isTokenCheck: action.payload && action.payload.status };
      break;

    case guestConstants.SET_PASSWORD_SUCCESS:
      currentstate = {
        passwordSetSuccess: action.payload && action.payload.status
      };
      break;
    //#endregion

    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
